import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import ModalService from "src/modals"
import { selectIsGuest } from "src/store/user"

/* The guest's way to keep the account (owner, 2026-10-02): "Guest — save your account", on the home
   page and in the profile. Renders nothing for anybody else, so a caller places it unconditionally. */
const SaveGuestButton = ({ className = "" }) => {
  const { t } = useTranslation()
  const isGuest = useSelector(selectIsGuest)
  if (!isGuest) return null

  return (
    <button
      type="button"
      className={`save-guest-button ${className}`.trim()}
      onClick={() => ModalService.show("SaveGuestModal")}
    >
      {t("guest.badge")} · {t("guest.saveCta")}
    </button>
  )
}

export default SaveGuestButton
